import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, isRef as _isRef, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/BG_header_cookies.png'


const _withScopeId = n => (_pushScopeId("data-v-5a76c75d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "modal-bg",
  ref: "modalBG"
}
const _hoisted_2 = { class: "flex justify-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Mega Cookies",
  src: _imports_0
}, null, -1))
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row full-width no-wrap justify-between items-center" }
const _hoisted_6 = { class: "q-mt-xl" }
const _hoisted_7 = { class: "font-l q-mt-sm" }
const _hoisted_8 = ["href"]
const _hoisted_9 = {
  key: 0,
  class: "q-mx-sm"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "q-mt-xl row justify-center" }
const _hoisted_12 = { class: "q-mt-xl" }
const _hoisted_13 = { class: "row no-wrap justify-between align-center" }
const _hoisted_14 = { class: "q-mb-none q-pb-none" }
const _hoisted_15 = { class: "text-caption cookies-explain" }
const _hoisted_16 = { class: "row no-wrap justify-between align-center" }
const _hoisted_17 = { class: "q-mb-none q-pb-none" }
const _hoisted_18 = { class: "text-caption cookies-explain" }
const _hoisted_19 = { class: "row no-wrap justify-between align-center" }
const _hoisted_20 = { class: "q-mb-none q-pb-none" }
const _hoisted_21 = { class: "text-caption cookies-explain" }
const _hoisted_22 = { class: "buttons q-mt-md" }

import {computed, ref, watch} from "vue";
import {useI18n} from "vue-i18n";

import {LanguageEnum} from "@/enums";
import {changeLanguage, initMegaCookie, setMegaCookieValues} from "@/helpers";
import {useAuthenticationStore} from "@/stores/authentication";

import MySeparator from "@/components/interface/MySeparator.vue";

import MyButton from "../interface/MyButton.vue";
import MySmallCheckbox from "../inputs/MySmallCheckbox.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CookieModal',
  props: {
    isDesktop: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit }) {

const props = __props as {
  isDesktop: boolean;
};

const {t, locale} = useI18n();




const mandatory = ref<boolean>(true);
const analyze = ref<boolean>(false);
const pub = ref<boolean>(false);

// Computed

const language = computed({
  get: () => locale.value as LanguageEnum,
  set: (value: LanguageEnum) => {
    changeLanguage(useAuthenticationStore(), value, locale);
  },
});

function selectLanguage(value: LanguageEnum): void {
  language.value = value;
}

function acceptAnalyze(): void {
  analyze.value = !analyze.value;
}

function acceptPub(): void {
  pub.value = !pub.value;
}

function acceptCookies(): void {
  analyze.value = true;
  pub.value = true;
  //iOS
  if (typeof window.DeviceOrientationEvent?.requestPermission === 'function' && window.DeviceOrientationEvent?.requestPermission) {
    window.DeviceOrientationEvent.requestPermission().then(permissionState => {
      if (permissionState === 'granted') {
        setCookies();
      } else {
        analyze.value = false;
        pub.value = false;
        setCookies();
      }
    }).catch(console.error);
  } else {
    //not iOS
    setCookies();
  }
}

function rejectCookies(): void {
  analyze.value = false;
  pub.value = false;

  setCookies();
}

function setCookies(): void {
  initMegaCookie();
  setMegaCookieValues(analyze.value, pub.value);
  close();
}

function close(): void {
  emit("close");
}

// Watchers

watch(language, (value: LanguageEnum) => {
  selectLanguage(value);
});

return (_ctx: any,_cache: any) => {
  const _component_SvgInline = _resolveComponent("SvgInline")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, null, 512)
      ]),
      _: 1
    }),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            id: "my-cookies",
            ref: "modal",
            class: _normalizeClass({ mobile: !__props.isDesktop }),
            role: "dialog"
          }, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_SvgInline, {
                  id: "logo",
                  name: "logo"
                }),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(language) ? (language).value = $event : null)),
                  class: "languages"
                }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(LanguageEnum), (lang) => {
                    return (_openBlock(), _createElementBlock("option", { key: lang }, _toDisplayString(lang), 1))
                  }), 128))
                ], 512), [
                  [_vModelSelect, _unref(language)]
                ])
              ]),
              _createVNode(MySeparator),
              _createElementVNode("h2", _hoisted_6, _toDisplayString(_unref(t)("Cookies.privacy")), 1),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_unref(t)("Cookies.disclaimer")), 1),
              _createVNode(MySeparator),
              _createElementVNode("p", {
                class: _normalizeClass([{column : !__props.isDesktop}, "justify-center q-mt-lg"])
              }, [
                _createTextVNode(_toDisplayString(_unref(t)("Cookies.MEGA_TELECOM")) + "   ", 1),
                _createElementVNode("a", {
                  href: _unref(t)('Cookies.COOKIES_LINK.LINK'),
                  class: "button button--link-bold underline font-s",
                  rel: "noopener noreferrer",
                  target: "_blank"
                }, _toDisplayString(_unref(t)("Cookies.COOKIES_LINK.LABEL")), 9, _hoisted_8),
                (__props.isDesktop)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "/"))
                  : _createCommentVNode("", true),
                _createElementVNode("a", {
                  href: _unref(t)('Cookies.PRIVACY_POLICY_LINK.LINK'),
                  class: "button button--link-bold underline font-s",
                  rel: "noopener noreferrer",
                  target: "_blank"
                }, _toDisplayString(_unref(t)("Cookies.PRIVACY_POLICY_LINK.LABEL")), 9, _hoisted_10)
              ], 2),
              _createElementVNode("div", _hoisted_11, [
                _createVNode(MyButton, {
                  class: "accept-all bg-primary",
                  onClick: acceptCookies
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Cookies.actions.accept")), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("ul", _hoisted_12, [
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", null, [
                      _createElementVNode("p", _hoisted_14, [
                        _createVNode(_component_SvgInline, { name: "arrowLi" }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)(`Cookies.cookies.${[0]}`)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)(`Cookies.COOKIES_EXPLAIN.${[0]}`)), 1)
                    ]),
                    _createVNode(MySmallCheckbox, {
                      disabled: true,
                      isDesktop: __props.isDesktop,
                      value: mandatory.value,
                      class: "check",
                      name: "arrowLi1"
                    }, null, 8, ["isDesktop", "value"])
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", { onClick: acceptAnalyze }, [
                      _createElementVNode("p", _hoisted_17, [
                        _createVNode(_component_SvgInline, {
                          class: "icon",
                          name: "arrowLi"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)(`Cookies.cookies.${[1]}`)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)(`Cookies.COOKIES_EXPLAIN.${[1]}`)), 1)
                    ]),
                    _createVNode(MySmallCheckbox, {
                      isDesktop: __props.isDesktop,
                      value: analyze.value,
                      class: "check",
                      name: "arrowLi2",
                      onClick: acceptAnalyze
                    }, null, 8, ["isDesktop", "value"])
                  ])
                ]),
                _createElementVNode("li", null, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", { onClick: acceptPub }, [
                      _createElementVNode("p", _hoisted_20, [
                        _createVNode(_component_SvgInline, {
                          class: "icon",
                          name: "arrowLi"
                        }),
                        _createTextVNode(" " + _toDisplayString(_unref(t)(`Cookies.cookies.${[2]}`)), 1)
                      ]),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_unref(t)(`Cookies.COOKIES_EXPLAIN.${[2]}`)), 1)
                    ]),
                    _createVNode(MySmallCheckbox, {
                      isDesktop: __props.isDesktop,
                      value: pub.value,
                      class: "check",
                      name: "arrowLi3",
                      onClick: acceptPub
                    }, null, 8, ["isDesktop", "value"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                (pub.value || analyze.value)
                  ? (_openBlock(), _createBlock(MyButton, {
                      key: 0,
                      class: "save-btn",
                      onClick: setCookies
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("Cookies.actions.save")), 1)
                      ]),
                      _: 1
                    }))
                  : (_openBlock(), _createBlock(MyButton, {
                      key: 1,
                      class: "bg-primary",
                      onClick: rejectCookies
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)("Cookies.actions.reject")), 1)
                      ]),
                      _: 1
                    })),
                _createVNode(MyButton, {
                  class: "bg-primary",
                  onClick: acceptCookies
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("Cookies.actions.accept")), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ], 2)
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})